export default "__VITE_ASSET__DDOr9QfO__"